/**
 * Rewrites image URLs that still point at a retired media host.
 *
 * The media service moved from img.gurukul365.com to img.kaympus.com with
 * the SAME paths (rebrand, 2026-07); the old hostname no longer resolves.
 * Thousands of stored URLs (school logos, theme previews, landing images)
 * were written before the move and would otherwise render as broken
 * images forever. Rewriting at read-time fixes every one of them without a
 * database migration, and is a no-op for anything already on the live host.
 *
 * Only the hostname changes — path and query are kept — so a file that
 * genuinely doesn't exist on the new host still fails and the caller's
 * fallback (SafeImage placeholder, onError) behaves exactly as before.
 */
const LEGACY_MEDIA_HOSTS = ['img.gurukul365.com'];

const CURRENT_MEDIA_ORIGIN = (
    process.env.NEXT_PUBLIC_MEDIA_BASE_URL || 'https://img.kaympus.com'
).replace(/\/+$/, '');

export function mediaUrl(url) {
    if (typeof url !== 'string' || !url) return url;
    try {
        const parsed = new URL(url);
        if (LEGACY_MEDIA_HOSTS.includes(parsed.hostname.toLowerCase())) {
            return `${CURRENT_MEDIA_ORIGIN}${parsed.pathname}${parsed.search}`;
        }
    } catch {
        // Relative or malformed — leave untouched.
    }
    return url;
}
